import { render, staticRenderFns } from "./SelectExtrusionOrderModal.vue?vue&type=template&id=224b878e&scoped=true&"
import script from "./SelectExtrusionOrderModal.vue?vue&type=script&lang=js&"
export * from "./SelectExtrusionOrderModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectExtrusionOrderModal.vue?vue&type=style&index=0&id=224b878e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224b878e",
  null
  
)

export default component.exports